import DateFnsUtils from "@date-io/date-fns";
import {
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import React from "react";
import { ValidatorComponent } from "react-material-ui-form-validator";

class InputDateTime extends ValidatorComponent {
  render() {
    const { errorMessages, validators, requiredError, value, ...rest } =
      this.props;

    return (
      <div>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDateTimePicker
            {...rest}
            value={value}
            ref={(r) => {
              this.input = r;
            }}
          />
        </MuiPickersUtilsProvider>
        {this.errorText()}
      </div>
    );
  }

  errorText() {
    const { isValid } = this.state;

    if (isValid) {
      return null;
    }

    return (
      <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">
        {this.getErrorMessage()}
      </p>
    );
  }
}

export default InputDateTime;
